import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Icon } from "antd";
import { ListGroup, ListGroupItem, FormInput, Button, Row, Col } from "shards-react";
import authStore, { types as authTypes, actions as authActions } from "../_stores/auth.store";
import navStore, { actions as navActions } from "../_stores/sidenav.store";
import UserService from "../services/user.service";
import logo from "../images/logo.png";
import { TiKeyOutline, TiUserOutline } from "react-icons/ti";
import { MsalContext } from "@azure/msal-react";
import { toast } from "react-toastify";

class UserLogin extends React.Component {
  static contextType = MsalContext;

  constructor(props) {
    super(props);
    this.state = {
      loginError: "",
    };
    this.userLogin = this.userLogin.bind(this);
    this.ssoLogIn = this.ssoLogIn.bind(this);
    this.showMessage = this.showMessage.bind(this);
    this.verifySsoUserInDB = this.verifySsoUserInDB.bind(this);
  }

  componentWillMount() {
    this.authUnsubscribe = authStore.subscribe(async () => {
      const ssoState = authStore.getState().sso_reducer;
      if (ssoState.account) {
        await this.verifySsoUserInDB("admin@iqvia.com");
        // ssoState.account.username
        //   ? await this.verifySsoUserInDB(ssoState.account.username)
        //   : this.setState({ loginError: "SSO Account username not found." });
      }
    });
  }

  componentWillUnmount() {
    this.authUnsubscribe();
  }

  showMessage({ msg, type }) {
    toast(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type,
    });
  }

  async userLogin(data) {
    try {
      const resp = await UserService.login(data);
      if (resp.data && resp.data.success) {
        await this.userProfile(resp.data.token);
      } else {
        this.setState({
          loginError: resp.data ? resp.data.message : "User Login Error",
        });
      }
    } catch (err) {
      console.error("User Login error catch => ", err);
      this.setState({ loginError: err.message });
    }
  }

  async userProfile(token) {
    try {
      const payload = { authToken: token };
      authStore.dispatch({ type: authTypes.SET_AUTH_STATE, payload });
      navActions.setSideNav(navStore.dispatch);
      const resp = await UserService.profile();
      if (resp.data && resp.data.success) {
        const payload = {
          isLoggedIn: true,
          user: resp.data.data,
        };
        authStore.dispatch({ type: authTypes.SET_AUTH_STATE, payload });
        authActions.setAuthStorage();
      } else {
        this.setState({
          loginError: resp.data ? resp.data.message : "User Profile Error",
        });
      }
    } catch (err) {
      console.error("User Profile error catch => ", err);
      this.setState({ loginError: err.message });
    }
  }

  async ssoLogIn() {
    try {
      const ssoResp = await this.context.instance.loginRedirect({
        scopes: ["User.Read"]
      });
      console.log("SSO Login Resp => ", ssoResp);
      console.log('this.context.accounts', this.context.accounts);
      // authStore.dispatch({ type: authTypes.SET_SSO_STATE, payload: ssoResp });
    } catch (err) {
      console.error("SSO Login catch => ", err);
      // this.showMessage({ msg: err.message, type: "error" });
      this.setState({ loginError: err.message });
    }
  }

  async verifySsoUserInDB(email) {
    try {
      const resp = await UserService.validateSsoUser({ email });
      if (resp.data && resp.data.success) {
        await this.userProfile(resp.data.token);
      } else {
        this.setState({
          loginError: resp.data ? resp.data.message : "SSO User Validate Error",
        });
      }
    } catch (err) {
      console.error("SSO User Validate error catch => ", err);
      this.setState({ loginError: err.message });
    }
  }

  render() {
    const { loginError } = this.state;

    return (
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string().email("Email is invalid").required("Email is required"),
          password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          this.userLogin(values);
        }}
      >
        {(props) => {
          const { values, touched, errors, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, handleReset } =
            props;
          return (
            <>
              {/* <!--Content before waves--> */}
              {/* <!--Waves Container--> */}
              <div className="waves-container">
                <svg
                  className="waves"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 24 150 28"
                  preserveAspectRatio="none"
                  shapeRendering="auto"
                >
                  <defs>
                    <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                  </defs>
                  <g className="parallax">
                    <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                    <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                    <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                    <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                  </g>
                </svg>
              </div>
              {/* <!--Waves end--> */}

              <div className="app bg-login">
                <Row className="row login-form">
                  <Col className="col-sm-5 offset-sm-1 login-img">
                    <img src={logo} className="logo-login" />
                    <div className="logo-text">Data Standardization Tool</div>
                  </Col>
                  <Col className="col-sm-5 p-0 login-content">
                    <div className="col-sm-12 mb-4 p-0 border-radius-0">
                      <h2>Login</h2>
                      <ListGroup flush>
                        <ListGroupItem className="">
                          <Form onSubmit={handleSubmit}>
                            <Row form>
                              <Col md="12" className="form-group">
                                <div className="form-fields">
                                  <div className="input-group ">
                                    <div className="input-group-prepend">
                                      <TiUserOutline size="24" color="white" />
                                    </div>
                                    <input
                                      id="email"
                                      type="email"
                                      value={values.email}
                                      className={
                                        errors.email && touched.email
                                          ? "text-input error form-control"
                                          : "text-input form-control"
                                      }
                                      placeholder="Email ID"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </div>
                                  {errors.email && touched.email && <div className="input-feedback">{errors.email}</div>}
                                </div>
                                <div className="form-fields">
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <TiKeyOutline size="24" color="white" />
                                    </div>
                                    <input
                                      id="password"
                                      type="password"
                                      value={values.password}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      className={
                                        errors.password && touched.password
                                          ? "text-input error form-control"
                                          : "text-input form-control"
                                      }
                                      placeholder="Password"
                                    />
                                  </div>
                                  {errors.password && touched.password && (
                                    <div className="input-feedback">{errors.password}</div>
                                  )}
                                </div>
                                {/* <Form.Item required>
                                <FormInput
                                  id="email"
                                  prefix={
                                    <Icon
                                      type="user"
                                      style={{ color: "rgba(0,0,0,.25)" }}
                                    />
                                  }
                                  placeholder="Enter your email"
                                  type="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  
                                />
                              
                              </Form.Item> */}

                                {/* <Form.Item required>
                                <FormInput
                                  id="password"
                                  prefix={
                                    <Icon
                                      type="lock"
                                      style={{ color: "rgba(0,0,0,.25)" }}
                                    />
                                  }
                                  placeholder="Enter your password"
                                  type="password"
                                  value={values.password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    errors.password && touched.password
                                      ? "text-input error"
                                      : "text-input"
                                  }
                                />
                                {errors.password && touched.password && (
                                  <div className="input-feedback">
                                    {errors.password}
                                  </div>
                                )}
                              </Form.Item> */}

                                <Form.Item>
                                  <Button
                                    type="primary"
                                    className="login-form-button"
                                    style={{ minWidth: "100%" }}
                                    onSubmit={handleSubmit}
                                  >
                                    Login
                                  </Button>
                                </Form.Item>

                                <Form.Item>
                                  <Button
                                    type="button"
                                    className="login-form-button"
                                    style={{ minWidth: "100%" }}
                                    onClick={this.ssoLogIn}
                                  >
                                    SSO Log in
                                  </Button>
                                </Form.Item>

                                {loginError ? <div className="input-feedback">{loginError}</div> : <></>}
                              </Col>
                            </Row>
                          </Form>
                        </ListGroupItem>
                      </ListGroup>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          );
        }}
      </Formik>
    );
  }
}

export default UserLogin;
